import { devMode } from 'scripts/util/env'
import { NONCE } from '../../shared/constants'
// import { buildQueryString } from '../../util/string'

const SUBMIT = 'ksk001/tippgeber/SUBMIT'
const SUBMIT_SUCCESS = 'ksk001/tippgeber/SUBMIT_SUCCESS'
const SUBMIT_FAILURE = 'ksk001/tippgeber/SUBMIT_FAILURE'
const PREFILL_FIELDS = 'ksk001/tippgeber/PREFILL_FIELDS'
const GET_CONTACT = 'ksk001/tippgeber/GET_CONTACT'
const RESET_SUCCESS = 'ksk001/tippgeber/RESET_SUCCESS'

export const initialState = {
  isSubmitting: false,
  error: false,
  success: false,
  initialValues: {
    anlass: 'kauf',
    c_country: 'DEU',
  },
  contact: null,
}

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SUBMIT:
      return {
        ...state,
        isSubmitting: true,
        error: false,
      }
    case SUBMIT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: payload.success,
      }
    case SUBMIT_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: payload.error,
      }
    case PREFILL_FIELDS:
      return {
        ...state,
        initialValues: { ...state.initialValues, ...payload },
      }
    case GET_CONTACT:
      return {
        ...state,
        contact: payload,
      }
    case RESET_SUCCESS:
      return {
        ...state,
        success: false,
      }
    default:
      return state
  }
}

export const prefillFields = () => dispatch => {
  return fetch(`/wp-json/dhsv/v1/tippgeber/prefill`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  }).then(response => {
    if (![200, 400].includes(response.status)) {
      const message = response.statusText
        ? response.status + ': ' + response.statusText
        : response.status

      throw new Error(message)
    }

    return response.json().then(json => {
      dispatch({
        type: PREFILL_FIELDS,
        payload: json,
      })

      return json
    })
  })
}

export const getContact = () => dispatch => {
  return fetch(`/wp-json/dhsv/v1/tippgeber/contact`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  }).then(response => {
    if (![200, 400].includes(response.status)) {
      const message = response.statusText
        ? response.status + ': ' + response.statusText
        : response.status

      throw new Error(message)
    }

    return response.json().then(json => {
      dispatch({
        type: GET_CONTACT,
        payload: json,
      })

      return json
    })
  })
}

export const submit = (values, form) => dispatch => {
  dispatch({
    type: SUBMIT,
  })

  return fetch('/wp-json/dhsv/v1/tippgeber', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': NONCE,
    },
    body: JSON.stringify(values), // Send values as JSON in the request body
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.status + ': ' + response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        if ('success' in json) {
          dispatch({
            type: SUBMIT_SUCCESS,
            payload: {
              success: json.success,
            },
          })

          form.restart()

          // setTimeout(() => {
          //   dispatch(resetSuccess())
          // }, 10000)
        }

        return json
      })
    })
    .catch(error => {
      if (devMode) {
        console.error(error) //eslint-disable-line
      }
      dispatch({
        payload: {
          error: error.message,
        },
        type: SUBMIT_FAILURE,
      })
      return Promise.reject(error)
    })
}

export const resetSuccess = () => dispatch => {
  dispatch({
    type: RESET_SUCCESS,
  })
}
